export function ActivatedRouteHasNewDesignParam(route) {
  console.log(`newDesign ${route?.snapshot?.data?.['newDesign']}`);
  return route?.snapshot?.data?.['newDesign'];
}
